import React from 'react';
import { useTranslation } from 'react-i18next';

import './index.less';

import IbIcon from '../../common/IbIcon';
import IbTypography from '../../common/IbTypography';

const MAIN_CLASS_NAME = 'runtime-error-event';
const SELECTED_CLASS_NAME = `${MAIN_CLASS_NAME}_selected`;
const ERROR_CLASS_NAME = `${MAIN_CLASS_NAME}_error`;
const DEFAULT_SIZE_CLASS_NAME = `${MAIN_CLASS_NAME}_size-default`;
const SMALL_SIZE_CLASS_NAME = `${MAIN_CLASS_NAME}_size-small`;
const ICON_CONTAINER_CLASS_NAME = `${MAIN_CLASS_NAME}__icon-container`;
const STATUS_CLASS_NAME = `${MAIN_CLASS_NAME}__status`;

export enum RuntimeErrorEventSize {
  DEFAULT = 'default',
  SMALL = 'small',
}

const iconSizeMap = {
  [RuntimeErrorEventSize.DEFAULT]: 20,
  [RuntimeErrorEventSize.SMALL]: 16,
};

const paragraphTypeMap = {
  [RuntimeErrorEventSize.DEFAULT]: 'normal' as const,
  [RuntimeErrorEventSize.SMALL]: 'secondary' as const,
};

export interface IRuntimeErrorEventProps {
  isSelected?: boolean;
  size?: RuntimeErrorEventSize;
  onSelect?: () => void;
}

const RuntimeErrorEvent: React.FC<IRuntimeErrorEventProps> = ({
  isSelected = false,
  size = RuntimeErrorEventSize.DEFAULT,
  onSelect,
}) => {
  const { t } = useTranslation();

  const classes = [MAIN_CLASS_NAME, ERROR_CLASS_NAME];
  if (isSelected) {
    classes.push(SELECTED_CLASS_NAME);
  }
  if (size === RuntimeErrorEventSize.DEFAULT) {
    classes.push(DEFAULT_SIZE_CLASS_NAME);
  }
  if (size === RuntimeErrorEventSize.SMALL) {
    classes.push(SMALL_SIZE_CLASS_NAME);
  }

  const onClick = () => onSelect?.();

  return (
    <div className={classes.join(' ')} onClick={onClick}>
      <div className={ICON_CONTAINER_CLASS_NAME}>
        <IbIcon iconName="user-business" size={iconSizeMap[size]} />
      </div>
      <IbTypography.Paragraph type={paragraphTypeMap[size]}>
        {t('Agent: Runtime error event: Title')}
      </IbTypography.Paragraph>
      <IbIcon className={STATUS_CLASS_NAME} iconName="attention" size={iconSizeMap[size]} />
    </div>
  );
};

export default RuntimeErrorEvent;
